module.exports = __webpack_public_path__ + "img/StatesIcon.107987e7.png";